import { Injectable, Injector } from '@angular/core';
import {SalesforceNamespace} from 'datasource-service-lib';
import {BullhornIconService, SalesforceIconService} from 'icon-service-lib';
import { InveniasIconService } from 'icon-service-lib';
import { IIconService } from 'interfaces-lib';
import { BullhornAuthService } from './auth/bullhorn.auth.service';
import { IAuthService } from './auth/iauthservice';
import { InveniasAuthService } from './auth/invenias.auth.service';
import {SalesforceAuthService} from './auth/salesforce.auth.service';
import { BaseMetaDataService } from './metadata/base-meta-data.service';
import { BullhornMetaDataService } from './metadata/bullhorn-meta-data.service';
import { DefaultMetaDataService } from './metadata/default-meta-data.service';
import { InveniasMetaDataService } from './metadata/invenias-meta-data.service';
import { SalesforceMetaDataService } from './metadata/salesforce-meta-data.service';

export const InveniasNamespace: INamespace = {
  name: 'invenias',
  aliases: ['inveniasnextgen'],
};
export const BullhornNamespace: INamespace = { name: 'bullhorn', aliases: [] };
export interface INamespace {
  name: string;
  aliases?: string[];
}

@Injectable({ providedIn: 'root' })
export class ServiceProviderService {
  constructor(private injector: Injector) {}

  getIconService(namespace: string): IIconService | undefined {
    if (namespace === InveniasNamespace.name) {
      return this.injector.get(InveniasIconService);
    }
    if (namespace === BullhornNamespace.name) {
      return this.injector.get(BullhornIconService);
    }
    if (namespace === SalesforceNamespace.name) {
      return this.injector.get(SalesforceIconService);
    }
    return undefined;
  }

  getAuthService(namespace: string): IAuthService {
    if (namespace === InveniasNamespace.name) {
      return this.injector.get(InveniasAuthService);
    }
    if (namespace === BullhornNamespace.name) {
      return this.injector.get(BullhornAuthService);
    }
    if (namespace === SalesforceNamespace.name) {
      return this.injector.get(SalesforceAuthService);
    }
    throw new Error(`No service found for namespace: ${namespace}`);
  }

  getMetaDataService(namespace: string): BaseMetaDataService {
    return this.resolveMetaDataService(namespace);
  }

  private resolveMetaDataService(namespace: string): BaseMetaDataService {
    if (namespace === InveniasNamespace.name) {
      return this.injector.get(InveniasMetaDataService);
    }
    if (namespace === BullhornNamespace.name) {
      return this.injector.get(BullhornMetaDataService);
    }
    if (namespace === SalesforceNamespace.name) {
      return this.injector.get(SalesforceMetaDataService);
    }
    return this.injector.get(DefaultMetaDataService);
  }
}
